import React, { useEffect, useMemo, useState } from "react";
import { config, PERMISSIONS } from "../../../../../config";
import axiosApi from "../../../../../core/interceptor/interceptor";
import "./Season.css";
import close from "../../../../../assets/close.svg";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { permissions } from "../../../../../Store/reducers/PermissionsReducer";
import _ from "lodash";

export default function ShowSeason(props) {
	const [loader, setLoader] = useState(true);
	const permission = useSelector(permissions);

	/***** getter and setter of seasons *****/
	const [seasons, setSeasons] = useState([]);

	/**** getter and setter of selected season index ******/
	const [selectedIndex, setSelectedIndex] = useState(null);
	const [filter, setFilter] = useState({ name: '' });
	useEffect(() => {
		if (props.emitSeason) {
			props.emitSeason(seasons[selectedIndex]);
		}
		//eslint-disable-next-line
	}, [selectedIndex, seasons])

	const getAllSeasons = (search = null) => {
		setLoader(true);
		axiosApi.get(`${config.apiUrl}/seasons`, { params: { search: search ? search : filter.name, } }).then((response) => {
			if (response.data.data) {
				setSeasons(() => {
					setSelectedIndex(0);
					if(props.NotShowAll){
						return response.data.data;
					}else{
						return [{ name: 'All', id: 0, }, ...response.data.data];
					}
					
				});
			}
			setLoader(false);
		}).catch((err) => {
			console.error(err);
			setLoader(false);
		}
		)
	}

	useEffect(() => {
		getAllSeasons(filter.name);
		//eslint-disable-next-line
	}, [filter.name]);

	const debouncedCheckSearch = useMemo(
		() => {
			return _.debounce((search_string) => {
				setFilter((prev) => ({ ...prev, name: search_string }));
			}, 1000);
		},
		[],
	);

	return <>
		<div className="modal-header">
			<h2>{props.copy ? 'Select Season To Copy To' : 'Change Season'}</h2>
			<p>Select a season  {Array.isArray(permission) && permission.includes(PERMISSIONS.LEAGUE_MODIFICATIONS) && <Fragment>
				or <span onClick={() => {
					props.showSeasons && props.showSeasons(false);
					props.setType && props.setType('add');
				}}>Add New Season</span>
			</Fragment>}
			</p>
			<span className="close" onClick={() => props && props.closeModal()}>
				<img src={close} alt='close-icon' />
			</span>
		</div>
		<div className="modal-body modal-body-seasons">
			<div className="input-blk">
				<input type="text" placeholder="Search season" onKeyUp={(e) => debouncedCheckSearch(e.target.value)} />
			</div>
			<div id="scrollableDiv" style={{ maxHeight: 350, overflow: "auto" }}>
				{
					seasons.length>1 ?
								seasons.map((season, index) => (
									<div key={`show-list-${index + 1}`} className={`inner-blk ${index === selectedIndex && 'active'}`}
										onClick={
											() => {
												setSelectedIndex(index);
											}
										}>
										<span>{season.name}</span>
									</div>))
						: (!loader && <div className="noSeason">No record found.</div>)
				}
			</div>
		</div>
	</>
}